export const Theme = {
    colors: {
        background: '#8783D1',
        stroke: '#886DE4',
        primary: '#5941A9',
        white: "white",
        observation: "#ABABAB",

        hover: {
            calculate: "#4F3998",
            clean: '#'        
        }
    },
    size: {
        description: '20px',
        title: '40px',
        subtitle: '25px',
        observation: '15px',
        mobile: {
            title: '30px'
        }
    }
}